import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { TequilaType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { TequilaProperties } from '@app/api/marketplace/models';

@Component({
  selector: 'app-tequila-properties-subform',
  templateUrl: './tequila-properties-subform.component.html',
  styleUrls: ['./tequila-properties-subform.component.scss'],
})
export class TequilaPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.TEQUILA_PROPERTIES';

  types = TequilaType;

  static buildForm(fb: FormBuilder, data?: TequilaProperties) {
    return fb.group({
      type: [data?.type, Validators.required],
    });
  }
}
